import ExhibitionSwitcherContainer from "../../../Component/ExhibitionSwitcher/ExhibitionSwitcherContainer";

/**
 * Shown right after login when multiple active exhibitions exist.
 * Only active exhibitions are presented so users cannot navigate
 * to a closed exhibition and accidentally mutate its data.
 */
const ExhibitionSwitcherPage = () => {
  return <ExhibitionSwitcherContainer activeOnly={true} />;
};

export default ExhibitionSwitcherPage;
